export default __webpack_public_path__ + "static/media/CAPWEB-Autorizaciones.aa5b5784.pdf";